module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc",
      "title": "Contents"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1"
    }
  }, [_vm._v("1: A Violinist and a Pastor")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2"
    }
  }, [_vm._v("2: In Whose Eyes?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Success in the Eyes of God")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: Experiencing Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: Grappling with Failure Theologically")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: More Truths of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: Responding to Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Helping Others")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ScriptureIndex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/endorsements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('em', [_vm._v("What God Thinks When We Fail")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/MoreTitlesfromIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles From InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0